import {getUrlQuery} from '~/utils/url';
import store from '~/store';
import {getActiveTests, noop} from '~/vendor/utils';
import {__STAGING__, __TEST__} from '~/utils/env';

const query = getUrlQuery();
let FullStory;
function fsToString(action) {
  return `FS - ${action}:`;
}

const formatActiveTests = () => {
  const activeTests = getActiveTests(store);
  return Object.keys(activeTests).reduce(
    (obj, key) => ({...obj, [`${removeVersion(key)}_str`]: activeTests[key]}),
    {}
  );
};

const removeVersion = flagName => {
  const versionIndex = flagName.indexOf('_');
  return versionIndex < 0 ? flagName : flagName.substr(0, versionIndex);
};

if (
  query.track === 'no' ||
  (import.meta.env.NDX_ENABLE_METRICS !== 'true' && __STAGING__)
) {
  FullStory = class {
    event(action, attributes = {}) {
      let combinedAttributes = {...attributes, ...formatActiveTests()};
      console.log(
        `${fsToString('Page Action')} ${action} \n${JSON.stringify(
          combinedAttributes
        )}`
      );
    }
  };
} else if (__TEST__) {
  FullStory = class {
    event(action, attributes = {}) {}
  };
} else {
  function safeFullStory(method) {
    if (window.FS && window.FS[method]) {
      return window.FS[method];
    }
    return noop;
  }
  FullStory = class {
    event(action, attributes = {}) {
      let combinedAttributes = {...attributes, ...formatActiveTests(store)};
      safeFullStory('event')(action, combinedAttributes);
    }
  };
}
const fullStory = new FullStory();
export {fullStory};
